var Theme= (value) => ({
    textColor:value ?  '#f2f2f2': '#222222' ,
    backgroundColor: value ? '#222222' : "#f2f2f2"
})

export default Theme;